import React, { useEffect, useState } from 'react';
import * as Sift from '@sift/types';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { useFormikContext } from 'formik';
import { HOME_URL, ATTRIBUTES_URL } from 'components/Router/consts';

import SubAttributesTable from './SubAttributesTable';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';

import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  attribute: Sift.Field;
  onChange: (field: string, value: any) => void;
  fields: Sift.Field[];
}

function AttributeReachOutToMeFor({ attribute, fields, onChange }: Props) {
  const classes = useStyles();
  const { dirty } = useFormikContext();
  const history = useHistory();
  const { objectKey } = useParams<{ objectKey: string }>();
  const shouldRenderFormat = attribute && objectKey === 'reachOutToMeFor';
  const [sortableFields, setSortableFields] = useState<(Sift.Field | undefined)[]>([]);

  useEffect(() => {
    if (shouldRenderFormat && fields && attribute.fields && !dirty) {
      setSortableFields(
        attribute.fields.map((fieldName: string) =>
          fields.find((f: Sift.Field) => f.objectKey === fieldName),
        ),
      );
    }
  }, [attribute, fields, dirty]);

  const handleAttributeOrderChange = (values: Sift.Field[]) => {
    onChange('client.fields', [
      ...values.map((value: Sift.Field) => value.objectKey),
      'reachOutToMeFor.general',
    ]);
  };

  const handleAddSubAttribute = () => {
    history.push(
      `${HOME_URL}${ATTRIBUTES_URL}/${attribute.entityField}/create?parentObjectKey=${attribute.objectKey}`,
    );
  };

  if (!shouldRenderFormat) {
    return null;
  }

  return (
    <div>
      <Card className={classes.cardRoot}>
        <CardHeader
          title="Sub-Attributes"
          subheader="Manage categorized sub-attributes, encouraging users to populate certain types of information like Projects, Initiatives, or Internal Systems for others to ask them questions about"
        />
        <CardContent>
          {sortableFields.length > 0 && (
            <SubAttributesTable
              list={sortableFields}
              editPriorityList={handleAttributeOrderChange}
            />
          )}
          <Button color="secondary" onClick={handleAddSubAttribute}>
            Add Sub-Attributes
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

const useStyles = makeStyles(() => ({
  root: {},
  cardRoot: {
    maxWidth: 900,
  },
}));

export default AttributeReachOutToMeFor;
